let filtersWindow = null;

export function openFiltersWindow() {
    

    if (filtersWindow && !filtersWindow.closed) {
      return true;
    }

    console.log('🪟 (local) Garantindo abertura da tela de filtros...');

    const win = window.open(
      `/filters${window.location.hash}`,
      '_blank'
    );

    if (!win) {
      filtersWindow = null;
      return false;
    }

    filtersWindow = win;
    return true;
}

export function closeFiltersWindow() {

  if (filtersWindow && !filtersWindow.closed) {

    console.log('🪟 (local) Fechando filtros na outra aba...');

    filtersWindow.close();

  }

  filtersWindow = null;
}